import { render, staticRenderFns } from "./SystemNotFound.vue?vue&type=template&id=069de6f5&"
import script from "./SystemNotFound.vue?vue&type=script&lang=js&"
export * from "./SystemNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports